import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { FindLoad, FindSuccessItem, Images, useModal } from 'utils';
import { fileActions, httpRequestsOnSuccessActions } from 'store';
import { TextareaCustom } from '../../form';
import { CreateChancel } from '../../buttons';
import { unShareFile } from '../../../store/file/file.action';

export const ShareFile = ({ item, reqParams, unShare }) => {
    const { handleSubmit, control, clearErrors, reset, setValue, watch } = useForm({});
    const ACTION_TYPE = unShare ? 'UN_SHARE_FILE' : 'SHARE_FILE';
    const dispatch = useDispatch();
    const loader = FindLoad(ACTION_TYPE);
    const success = FindSuccessItem(ACTION_TYPE);
    const { close } = useModal();

    useEffect(() => {
        if (success) {
            close();
            dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE));
        }
    }, [success]);

    const handleShare = (data) => {
        if (unShare) {
            dispatch(fileActions.unShareFile(reqParams, reqParams?.id, item?.id, data));
        } else {
            dispatch(fileActions.shareFile(reqParams, reqParams?.id, item?.id, data));
        }
    };

    return (
        <div style={{ width: 400 }}>
            <p className="modal-header-title">{unShare ? 'Unshare File from Client' : 'Share with Client'}</p>
            <p className="modal-header-sub">
                {unShare
                    ? 'Are you sure you want to unshare this file? It will no longer be visible to the client in their portal.'
                    : 'This file will be visible to the client'}
            </p>
            <div className="modal-header-line" />

            <div
                style={{ borderColor: unShare ? '#F04438' : '#0C66E3', marginBottom: unShare ? '32px' : '24px' }}
                className="file-sharing-info-box"
            >
                <img src={unShare ? Images.fileRedIcon : Images.fileBlueIcon} alt="fileBlueIcon" />
                <div>
                    <p>{item?.name}</p>
                    <span style={{ marginTop: 8 }}>{item?.description}</span>
                </div>
            </div>

            <form onSubmit={handleSubmit(handleShare)}>
                {!unShare && (
                    <div>
                        <p className="file-sharing-message">Message</p>
                        <TextareaCustom
                            control={control}
                            name="message"
                            label="Message"
                            variant={'outlined'}
                            allowCharacter={true}
                            maxLength={100}
                        />
                    </div>
                )}
                <CreateChancel
                    redBtn={unShare}
                    type="submit"
                    loader={!!loader.length}
                    create={unShare ? 'Unshare' : 'Share File'}
                    chancel={'Cancel'}
                    onClose={close}
                    buttonWidth="100%"
                />
            </form>
        </div>
    );
};
